import React from "react";
import Image from "../images/404.svg";

const Page404 = () => {
  return (
    <div className="not-found-cont">
      <img src={Image} alt="404" />
    </div>
  );
};

export default Page404;
